import BaseService from "@client.services/baseService";

export default class CalendarService extends BaseService {
  constructor() {
    super("calendar", true);
  }

  async sync(isGoogle) {
    return super.post(`sync`, { isGoogle });
  }
}
